import { responseDataFormate } from "./bycrypt";
import { alias } from "./utils";
import { Capacitor } from "@capacitor/core";

// Define a type for the dispatch function
type Dispatch = (action: {
  type: string;
  payload: { scope: string; status?: boolean | string | string[] };
}) => void;

// Error Handling Functions
export const dispatchLoading = (
  dispatch: Dispatch,
  scope: string,
  status: boolean
) => dispatch({ type: "SET_LOADING", payload: { scope, status } });

export const dispatchToast = (
  dispatch: Dispatch,
  scope: string,
  status: boolean | string
) => dispatch({ type: "SET_TOAST", payload: { scope, status } });

export const dispatchError = (
  dispatch: Dispatch,
  scope: string,
  status: string[] | string | undefined
) => dispatch({ type: "SET_ERROR", payload: { scope, status } });

interface Data {
  message: string;
  error: string;
}
// export const catchHandler = (dispatch: Dispatch, scope: Scope) => (err: AxiosErrorResponse) => {
export const catchHandler =
  (dispatch: any, scope: any, loaderScope?: any): any =>
  (err: any) => {
    if (err?.code === "ERR_CANCELED") {
      return;
    }

    // 444 = custom "token expired / invalid" status set by the backend.
    // Only this specific status triggers a logout+redirect to avoid false
    // positives from unrelated APIs that might also return 401.
    if (err?.response?.status === 444) {
      dispatchLoading(dispatch, loaderScope ?? scope, false);
      Reset();
      return;
    }

    let errMsg = err?.response?.data?.msg
      ? err?.response?.data?.msg
      : err?.response?.data?.message
      ? err?.response?.data?.message
      : err?.response?.data?.error
      ? err?.response?.data?.error
      : "Something went wrong";
    dispatchToast(dispatch, "error", errMsg);
    if (err.code === "ERR_NETWORK")
      dispatchToast(dispatch, "error", "Unable to connect to server");
    else if (err?.response?.status !== 401) {
      dispatchError(dispatch, scope, [errMsg]);
    } else if (err?.response?.status === 401) {
      dispatchError(dispatch, scope, [errMsg]);
      // window.location.assign(`${CLIENT_URL}/auth/login`);
    } else dispatchToast(dispatch, "error", errMsg);
    dispatchLoading(dispatch, loaderScope ?? scope, false);
    dispatchError(dispatch, scope, [errMsg]);
  };

export const elseHandler = (dispatch: Dispatch, scope: string, data: Data) => {
  dispatchToast(dispatch, "error", data?.message);
  dispatchError(dispatch, scope, data?.error);
};
export const Reset = () => {
  localStorage.clear();
  const loginPath = `${alias ? `/${alias}` : ""}/login`;
  if (Capacitor.isNativePlatform()) {
    window.location.replace(loginPath);
    return;
  }
  const base = (process.env.PUBLIC_URL ?? "").replace(/\/+$/, "");
  if (base.startsWith("http://") || base.startsWith("https://")) {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      window.location.replace(loginPath);
      return;
    }
  }
  window.location.replace(`${base}/login`);
};
